export const landingPage = {
  get_started: 'Get Started',
  header: 'Where Medi-Share Members Gather to Pray',
  prayerstream: 'PrayerStream',
  subheader: `PrayerStream is more than a chat—it's a meaningful point of connection for Medi-Share members.
This unique experience builds faith-filled connections and points to God's goodness and care for His people.`,
} as const;

export type LandingPageNamespace = Record<keyof typeof landingPage, string>;
